import { createBrowserRouter, Navigate } from "react-router-dom";
import { AppLayout } from "@/components/AppLayout";
import Dashboard from "@/pages/Dashboard";
import TournamentList from "@/pages/TournamentList";
import TournamentDetail from "@/pages/TournamentDetail";
import CheckpointTexts from "@/pages/CheckpointTexts";
import CheckpointFlyer from "@/pages/CheckpointFlyer";
import SendingsMonitor from "@/pages/SendingsMonitor";
import SocialCalendar from "@/pages/SocialCalendar";
import GlobalCalendar from "@/pages/GlobalCalendar";
import Clients from "@/pages/Clients";
import ClientsHistory from "@/pages/ClientsHistory";
import TournamentNew from "@/pages/TournamentNew";
import TournamentEdit from "@/pages/TournamentEdit";
import PlaytomicImport from "@/pages/PlaytomicImport";
import MessagingHub from "@/pages/MessagingHub";
import Automations from "@/pages/Automations";
import Community from "@/pages/Community";
import Players from "@/pages/playtomic/Players";
import Chat from "@/pages/playtomic/Chat";
import MatchesPublic from "@/pages/playtomic/MatchesPublic";
import MatchesPrivate from "@/pages/playtomic/MatchesPrivate";
import Clubs from "@/pages/playtomic/Clubs";
import PtCommunity from "@/pages/playtomic/Community";
import Lessons from "@/pages/playtomic/Lessons";
import Rankings from "@/pages/playtomic/Rankings";
import Stats from "@/pages/playtomic/Stats";
import Profile from "@/pages/playtomic/Profile";
import GareHome from "@/pages/gare/GareHome";
import GaraPage from "@/pages/gare/GaraPage";
import StaffShell from "@/pages/gare/StaffShell";
import PrintSheet from "@/pages/gare/PrintSheet";

export const router = createBrowserRouter([
  // App staff (Fabio, istruttori): accesso con nome + PIN, solo Gestione Tornei
  {
    path: "/staff",
    element: <StaffShell />,
    children: [
      { index: true, element: <GareHome /> },
      { path: "gara/:id", element: <GaraPage /> },
      { path: "gara/:id/stampa", element: <PrintSheet /> },
      { path: "*", element: <Navigate to="/staff" replace /> },
    ],
  },
  {
    path: "/",
    element: <AppLayout />,
    children: [
      { index: true, element: <Dashboard /> },
      { path: "tournaments", element: <TournamentList /> },
      { path: "tournaments/new", element: <TournamentNew /> },
      { path: "tournaments/import-playtomic", element: <PlaytomicImport /> },
      { path: "tournaments/:slug", element: <TournamentDetail /> },
      { path: "tournaments/:slug/edit", element: <TournamentEdit /> },
      {
        path: "tournaments/:slug/checkpoint/texts",
        element: <CheckpointTexts />,
      },
      {
        path: "tournaments/:slug/checkpoint/flyer",
        element: <CheckpointFlyer />,
      },
      { path: "tournaments/:slug/sendings", element: <SendingsMonitor /> },
      { path: "tournaments/:slug/calendar", element: <SocialCalendar /> },
      { path: "messaging", element: <MessagingHub /> },
      { path: "automations", element: <Automations /> },
      { path: "community", element: <Community /> },
      { path: "gare", element: <GareHome /> },
      { path: "gare/:id", element: <GaraPage /> },
      { path: "gare/:id/stampa", element: <PrintSheet /> },
      { path: "calendar", element: <GlobalCalendar /> },
      { path: "clients", element: <Clients /> },
      { path: "clients/history", element: <ClientsHistory /> },
      { path: "playtomic/players", element: <Players /> },
      { path: "playtomic/chat", element: <Chat /> },
      { path: "playtomic/matches-public", element: <MatchesPublic /> },
      { path: "playtomic/matches-private", element: <MatchesPrivate /> },
      { path: "playtomic/clubs", element: <Clubs /> },
      { path: "playtomic/community", element: <PtCommunity /> },
      { path: "playtomic/lessons", element: <Lessons /> },
      { path: "playtomic/rankings", element: <Rankings /> },
      { path: "playtomic/stats", element: <Stats /> },
      { path: "playtomic/profile", element: <Profile /> },
      { path: "*", element: <Navigate to="/" replace /> },
    ],
  },
]);
